import { Component, ViewChild, TemplateRef, ElementRef, Input, Output, EventEmitter, OnInit } from "@angular/core";
@Component({
    selector: "dynamic-grid",
    templateUrl: "./dynamicGrid.component.html"
})
export class dynamicGridComponent implements OnInit {
    showSumRow: any = false;
    gridHeight: any;
    innerWidth: any;
    columnSource: any;
    columnName: any;
    isNoData: boolean;
    errorMessage: string;
    loading: boolean;
    @Input() set rowData(val) {
        this.setRowData(val);
        this.subTotal();
    }
    @Input() set colData(val) {
        this.setColData(val);
    }
    @Input() set sumRow(val) {
        this.showSumRow = val;
    }
    @Input() set height(val) {
        this.gridHeight = val;
    }
    @Input() set dynamicColumnSource(val) {
        this.columnSource = val;
    }
    @Input() set dynamicColumnName(val) {
        this.columnName = val;
    }
    @Input() set inner_scroll_width(val) {
        this.innerWidth = val;
    }
    @Input() set loadingIndicator(val){
        this.loading = val;
    }

    column: any;
    data = [];
    sumData = 0;

    constructor(){
        this.loading = false;
    }

    ngOnInit() {
        this.gridHeight = (this.gridHeight / 1.3) + "vh";
    }

    setRowData(data) {
        this.data = data;
    }

    checkData(){
        this.isNoData = (this.data.length == 0)?true:false;
        this.errorMessage = "There is no data available.!!";
        return this.isNoData;
    }

    checkLoader(){
        return this.loading;
    }

    setColData(col) {
        let that = this;
        let innerCol = [];
        this.column = [];
        col.map(res => {
            if (res.innerScroll) {
                innerCol.push(res);
            } else {
                if (innerCol.length > 0){
                    that.column.push({ 'innerScroll': innerCol });
                    innerCol = [];
                }
                that.column.push(res);
            }
        });
        if (innerCol.length > 0)
            that.column.push({ 'innerScroll': innerCol });
    }

    getClass(col) {
        var cls = "text-left";
        if (col) {
            if (col.cell_align == 'right') {
                cls = "text-right";
            }
            else if (col.cell_align == 'center') {
                cls = "text-center";
            }
            if (col.width) {
                cls += " widthPx-" + (col.width * 2);
            }
        }
        return cls;
    }


    subTotal() {
        let that = this;
        let start = 0;
        if (that.column && that.data) {
            that.column.map((colRes) => {
                if (colRes.sumRow) {
                    that.data.map((rowRes, index) => {
                        if (index != 0) {
                            colRes['sum'] += (rowRes[colRes.prop]) ? rowRes[colRes.prop] : 0;
                        } else {
                            colRes['sum'] = (rowRes[colRes.prop]) ? rowRes[colRes.prop] : 0;
                        }
                    });
                }
            });
        }
    }

    numFormat(num) {
        if (num)
            return num.toFixed(2);
    }

}


// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/common/dynamicGrid.component.ts